import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsGlobalEntityGroup from "./InsightsGlobalEntityGroup";
import type InsightsRating from "./InsightsRating";
import type Organisation from "./Organisation";

enum InsightsEntityType {
  "Sentiment" = 0,
  "Highlight" = 1,
  "Spokesperson" = 2,
}

@Model()
class InsightsEntity extends ApplicationRecord {
  static jsonapiType = "insights_entities";

  @Attr() archivedAt: string;

  @Attr() color: string;

  @Attr() entityType: InsightsEntityType;

  @BelongsTo() globalEntityGroup: InsightsGlobalEntityGroup;

  @Attr() globalEntityGroupId: number;

  @HasMany() insightsRatings: InsightsRating[];

  @Attr() keywords: string[];

  @Attr() label: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() position: number;
}

export default InsightsEntity;
